let url = new URL(location);
const params = url.searchParams
let payload = {
  attributes: {}
};
let utm_found = false;
for (const [key, val] of params.entries()) {
  if(key.includes('utm')) {
    utm_found = true;
    payload.attributes[key] = val;
  }
}
if (utm_found) {
  Shopify.cartQueue.enqueue({
    url: `${Shopify.routes.root}cart/update.js`, 
    options: {
      body: JSON.stringify(payload),
      method: "POST",
      headers: {
        "Content-Type": "application/json", 
        "Accept": "application/json"
      }
    },
    callback: (json) => {
      if(!!payload.attributes) {
        Object.keys(payload.attributes).forEach(key => {
          url.searchParams.delete(key);
        });
      }
      window.history.replaceState(null,'', url)
    },
    error: (error) => {}
  });
}